import { get, includes, toLower } from "lodash";
import React from "react";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { expenseTypes } from "../types/expenseTypes";
import { leaseTypeFinancialTypes } from "../types/leaseTypeFinancialTypes";
import "./FinancialInformation.css";

const FinancialInformation = (props) => {
    const { compStatus, disableInputs, errors, listing, suppressRequired } = props;

    const displayRequired = !(suppressRequired === true);
    const handleInputChange = (event) => {
        props.handleInputChange("listing." + event.target.id, event.target.value);
    };
    const useType = get(listing, "attributes.useType");
    const disableForOutside = includes(["Outside Draft", "Outside"], compStatus);
    const isLeaseListing = includes(["lease", "for lease"], toLower(get(listing, "listingType")));
    const isSaleListing = includes(["sale", "for sale"], toLower(get(listing, "listingType")));

    return (
        <React.Fragment>
            {isLeaseListing && (
                <div>
                    <div className="financialInformationFlexContainer">
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <BSSelect
                                    id="leaseType"
                                    label={displayRequired ? "Lease Type*" : "Lease Type"}
                                    helperText={disableForOutside ? "" : displayRequired ? "Required" : ""}
                                    errorText={disableForOutside ? "" : "Required"}
                                    value={get(listing, "leaseType")}
                                    error={disableForOutside ? "" : get(errors, "leaseType")}
                                    onChange={handleInputChange}
                                    placeholder="Select lease type..."
                                    disabled={disableInputs}
                                    options={[
                                        {
                                            value: "",
                                            label: "Select",
                                            disabled: true,
                                        },
                                        ...leaseTypeFinancialTypes,
                                    ]}
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="improvementAllowance"
                                    label="Improvement Allowance"
                                    value={get(listing, "improvementAllowance")}
                                    error={get(errors, "improvementAllowance")}
                                    onChange={handleInputChange}
                                    placeholder="$_._/SF"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                        </div>
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <BSSelect
                                    id="expenseType"
                                    label="Expense Type"
                                    value={get(listing, "expenseType")}
                                    error={get(errors, "expenseType")}
                                    onChange={handleInputChange}
                                    placeholder="Select an expense type..."
                                    disabled={disableInputs}
                                    options={[
                                        {
                                            value: "",
                                            label: "Select an expense type...",
                                        },
                                        ...expenseTypes,
                                    ]}
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="expenseTypeValue"
                                    value={get(listing, "expenseTypeValue")}
                                    error={get(errors, "expenseTypeValue")}
                                    onChange={handleInputChange}
                                    placeholder={"Enter year"}
                                    disabled={disableInputs || listing.expenseType !== "baseYear"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="financialInformationFlexContainer">
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="askingRentMax"
                                    label={displayRequired ? "Base Rent/SF/Mth*" : "Base Rent/SF/Mth"}
                                    helperText={disableForOutside ? "" : displayRequired ? "Required" : ""}
                                    errorText={disableForOutside ? "" : "Required (ex. 981.01)"}
                                    toolTipText="Enter '0' to display 'Call Broker' on Kidder.com"
                                    value={get(listing, "askingRentMax")}
                                    error={disableForOutside ? "" : get(errors, "askingRentMax")}
                                    onChange={handleInputChange}
                                    placeholder="_._SF/MTH"
                                    startAdornment="$"
                                    disabled={disableInputs}
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="baseRentPerYear"
                                    label={displayRequired ? "Base Rent/SF/Year*" : "Base Rent/SF/Year"}
                                    helperText={disableForOutside ? "" : displayRequired ? "Required" : ""}
                                    errorText={disableForOutside ? "" : "Required (ex. 981.01)"}
                                    toolTipText="Enter '0' to display 'Call Broker' on Kidder.com"
                                    value={get(listing, "baseRentPerYear")}
                                    error={disableForOutside ? "" : get(errors, "baseRentPerYear")}
                                    onChange={handleInputChange}
                                    placeholder="_._SF/YR"
                                    startAdornment="$"
                                    disabled={disableInputs}
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="askingRentPerMonth"
                                    label={displayRequired ? "RENT/MONTH*" : "RENT/MONTH"}
                                    helperText={disableForOutside ? "" : displayRequired ? "Required" : ""}
                                    errorText={disableForOutside ? "" : "Required (ex. 981.01)"}
                                    value={get(listing, "askingRentPerMonth")}
                                    error={disableForOutside ? "" : get(errors, "askingRentPerMonth")}
                                    onChange={handleInputChange}
                                    placeholder="_._/MTH"
                                    startAdornment="$"
                                    disabled={disableInputs}
                                />
                            </div>
                        </div>
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="nnnPerMonth"
                                    label="Operating/CAM/NNN Cost/Mth"
                                    value={get(listing, "nnnPerMonth")}
                                    error={get(errors, "nnnPerMonth")}
                                    errorText="Must be a number (ex. 5.70)"
                                    onChange={handleInputChange}
                                    placeholder="_._SF/MTH"
                                    startAdornment="$"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="nnnPerYear"
                                    label="Operating/CAM/NNN Cost/Yr"
                                    value={get(listing, "nnnPerYear")}
                                    error={get(errors, "nnnPerYear")}
                                    errorText="Must be a number (ex. 5.70)"
                                    onChange={handleInputChange}
                                    placeholder="_._SF/YR"
                                    startAdornment="$"
                                    disabled={disableInputs}
                                    numeric
                                />
                            </div>
                        </div>
                    </div>

                    <div className="financialInformationFlexContainer financialInformationAlignLastBaseline">
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="totalMonthlyRent"
                                    label="Total Rent per SF per Mth"
                                    errorText={disableForOutside ? "" : "Required (ex. 981.01)"}
                                    value={get(listing, "totalMonthlyRent")}
                                    error={disableForOutside ? "" : get(errors, "totalMonthlyRent")}
                                    onChange={handleInputChange}
                                    placeholder="_._SF/MTH"
                                    startAdornment="$"
                                    disabled={true}
                                />
                            </div>
                            <div className="financialInformationFlexField">
                                <BSInput
                                    id="totalRentPerYear"
                                    label="Total Rent per SF per Yr"
                                    errorText={disableForOutside ? "" : "Required (ex. 981.01)"}
                                    value={get(listing, "totalRentPerYear")}
                                    error={disableForOutside ? "" : get(errors, "totalRentPerYear")}
                                    onChange={handleInputChange}
                                    placeholder="$_._SF/YR"
                                    startAdornment="$"
                                    disabled={true}
                                />
                            </div>
                        </div>
                        <div className="financialInformationFlexContainerUnresponsive">
                            <div className="financialInformationFlexField">
                                <h3>Commission Structure</h3>
                                <BSInput
                                    id="procuringBrokerCommission"
                                    label="Procuring Broker Commission %"
                                    value={get(listing, "procuringBrokerCommission")}
                                    error={get(errors, "procuringBrokerCommission")}
                                    onChange={handleInputChange}
                                    placeholder="Enter %"
                                    disabled={disableInputs}
                                    endAdornment="%"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isSaleListing && (
                <div>
                    <div className="financialInformationFlexContainer">
                        <div className="financialInformationFlexField">
                            <BSInput
                                id="listPrice"
                                label={displayRequired ? "List Price*" : "List Price"}
                                helperText={displayRequired ? "Required" : ""}
                                errorText="Required (ex. 98101)"
                                value={get(listing, "listPrice")}
                                error={get(errors, "listPrice")}
                                onChange={handleInputChange}
                                startAdornment="$"
                                placeholder='Enter amount "0" entry = Call Broker'
                                disabled={disableInputs}
                                numeric
                            />
                        </div>
                        {useType !== "Land" && useType !== "Hospitality" && (
                            <div className="financialInformationFlexField">
                                <div className="financialInformationFlexField">
                                    <BSInput
                                        id="capRate"
                                        label="Cap Rate"
                                        value={get(listing, "capRate")}
                                        error={get(errors, "capRate")}
                                        onChange={handleInputChange}
                                        errorText="Must be a number (ex. 5.7)"
                                        placeholder="Enter cap rate % (optional)"
                                        disabled={disableInputs}
                                        endAdornment="%"
                                        numeric
                                    />
                                </div>
                            </div>
                        )}
                        {useType !== "Land" && useType !== "Hospitality" && (
                            <div className="financialInformationFlexField">
                                <div className="financialInformationFlexField">
                                    <BSInput
                                        id="attributes.percentLeased"
                                        label="OCCUPANCY RATE"
                                        placeholder="Enter occupancy rate"
                                        error={get(errors, "attributes.percentLeased")}
                                        value={get(listing, "attributes.percentLeased")}
                                        onChange={handleInputChange}
                                        disabled={disableInputs}
                                        endAdornment="%"
                                        numeric
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="financialInformationFlexContainer">
                        <div className="financialInformationFlexField">
                            <h3>Commission Structure</h3>
                            <BSInput
                                id="procuringBrokerCommission"
                                label="Procuring Broker Commission %"
                                value={get(listing, "procuringBrokerCommission")}
                                error={get(errors, "procuringBrokerCommission")}
                                onChange={handleInputChange}
                                placeholder="Enter %"
                                disabled={disableInputs}
                                endAdornment="%"
                            />
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default FinancialInformation;
